import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d33d836"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brush-map__actions" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import IconTemplate from '@/apps/components/IconTemplate.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  firm: Object,
},
  setup(__props) {



const route = useRoute()
const isPreviewMode = computed(() => route.query['view-mode'] === '1')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["brush-map__header", { 'brush-map__header_preview': _unref(isPreviewMode) }])
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass([{ 'brush-map__title_preview': _unref(isPreviewMode) }, "brush-map__title"])
    }, " LUNA ", 2),
    _createElementVNode("div", _hoisted_1, [
      (!_unref(isPreviewMode))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openTipWindow')))
          }, [
            _createVNode(IconTemplate, {
              name: "tip",
              width: "25",
              height: "25"
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(isPreviewMode))
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: _normalizeClass({
            firm__button: __props.firm.nameFirm !== 'Curaprox',
            'firm__button--curaprox': __props.firm.nameFirm === 'Curaprox',
          })
          }, _toDisplayString(__props.firm.nameFirm), 3))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})